import React, {useContext, useState, useEffect} from 'react'
import { View, Text, TouchableOpacity } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { CredentialsContext } from '../components/CredentialsContext';
import useWebSocket from 'react-native-use-websocket';

import RootStack from './RootStack';
import SenariosScreen from '../screens/SenariosScreen';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';
import BoldStyledText from '../components/BoldStyledText';

import { AntDesign } from '@expo/vector-icons'; 

const Tab = createBottomTabNavigator();

const BottomTabBar = ({state, descriptors, navigation}) => {
    return(
        <View style={{flexDirection: 'row'}}>
            {state.routes.map((route, index) => {
                const { options } = descriptors[route.key];
                const label = 
                    options.tabBarLable !== undefined
                        ? options.tabBarLable
                        : options.title !== undefined
                        ? options.title
                        : route.name
                const isFocused = state.index === index;

                const onPress = () => {
                    const event = navigation.emit({
                        type: 'tabPress',
                        target: route.key,
                        canPreventDefault: true
                    });
                    if(!isFocused && !event.defaultPrevented) {
                        navigation.navigate({ name: route.name, merge: true });
                    }
                }
                
                const onLongPress = () => {
                    navigation.emit({
                        type: 'tabLongPress',
                        target: route.key,
                    })
                }

                return (
                    <TouchableOpacity
                        accessibilityRole='button'
                        accessibilityState={isFocused ? {selected: true} : {}}
                        accessibilityLabel={options.tabBarAccessibilityLabel}
                        testID={options.tabBarTestID}
                        onPress={onPress}
                        onLongPress={onLongPress}
                        style={{flex: isFocused ? 2 : 1, alignItems: 'center', backgroundColor: isFocused ? '#e88804': '#585951' , padding: 10 }}
                    >
                        <BoldStyledText style={{color: '#222', fontSize: 20}}>
                            {label}
                        </BoldStyledText>
                    </TouchableOpacity>
                )
            })}

        </View>
    )
}

const BottomTabNav = props => {
    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);

    const [isTokenValidated, setIsTokenValidated] = useState(true)
    const [token, setToken] = useState('')

    const [selectedModulesHelper, setSelectedModulesHelper] = useState(0)

    const welcomeMsg = {
        CTY: 'mc',
        DID: storedCredentials.userPhoneNumber,
    }
//  const { sendMessage, lastJsonMessage, lastMessage, readyState } = useWebSocket('ws://185.231.115.232:5050', {  
    const { sendMessage, lastJsonMessage, lastMessage, readyState } = useWebSocket('ws://185.231.115.232:5001', {  
        share: true,
        onOpen: () => {
            sendMessage(JSON.stringify(welcomeMsg))
            // console.log('connected from BTN')
        },
        // onOpen: () => {
        //     const d = new Date();
        //     let time = d.getTime();
        //     time = Math.floor(time/1000).toString() + envVars.SECRET
        //     const salt = bcryptjs.genSaltSync(10);
        //     const hash = bcryptjs.hashSync(time, salt);
        //     setToken(hash)

        //     const welcomeMsg = {
        //         CTY: 'mc',
        //         DID: storedCredentials.userPhoneNumber,
        //         token: hash
        //     }
        //     sendMessage(JSON.stringify(welcomeMsg))
        // },
        retryOnError: true,
        reconnectAttempts: 15,
        shouldReconnect: (CloseEvent) => true,
    })

    useEffect(()=> {
        if(!storedCredentials.senarios){
            const updatedStoredCredentials = {...storedCredentials, ...{senarios: []}}
            AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
            .then(()=> {
                setStoredCredentials(updatedStoredCredentials)  
                // setSelectedRoomsHelper(selectedModulesHelper - 1)
 
                NetInfo.fetch().then(state=> {
                    if(state.isConnected){
                        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
                        const credentials = {
                            userPhoneNumber: storedCredentials.userPhoneNumber,
                            data: {newSenario: updatedStoredCredentials.senarios} 
                        }
                        axios.post(url, credentials)
                        .catch(err=> {console.log(err);})
                    }
                })
            }).catch(err=> {console.log(err);})
        }
    }, [])
    useEffect(()=> {
        // console.log('lastMSGfromRootStack: ', lastMessage.data)
        if(lastMessage.data == 'token validated!'){
            setIsTokenValidated(true)

            AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                storedData = JSON.parse(storedData);
                storedData = {...storedData, ...{token: token}}
                AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(storedData));
                
            })
            .catch((err) => console.log(err))
        } 
    }, [lastMessage])

    const strings = () => {
        if(storedCredentials.language == 'English') {
            return EnglishStrings
        } else if(storedCredentials.language == 'Arabic') {
            return ArabicStrings
        } else return PersianStrings
    }

    return (
        <NavigationContainer independent={true}>
            <Tab.Navigator
                // screenOptions={{headerShown: false}}
                initialRouteName='RootStack'
                backBehavior='history'
                tabBar={props => <BottomTabBar {...props}/> }
            >
                <Tab.Screen 
                    name='BottomTabSenarioScreen' 
                    // component={SenariosScreen}
                    options={{
                        title:  strings().senarios,
                        tabBarIcon: (tabInfo) => {
                            return (
                                <AntDesign name='home' size={28} />
                            )
                        }
                        
                    }}    
                >
                    {props=> <SenariosScreen {...props} socket={{sendMessage: sendMessage, lastMessage: lastJsonMessage, readyState: readyState}} isTokenValidated = {isTokenValidated}  token = {token}/>}
                </Tab.Screen>
                <Tab.Screen 
                    name='RootStack' 
                    // component={RootStack}
                    options={{
                        title: strings().home,
                        tabBarIcon: (tabInfo) => {
                            return (
                                <AntDesign name='home' size={28} />
                            )
                        }}
                        
                    }
                >
                    {props=> <RootStack {...props} socket={{sendMessage: sendMessage, lastMessage: lastJsonMessage, readyState: readyState}} isTokenValidated = {isTokenValidated}  token = {token}/>}
                </Tab.Screen>
            </Tab.Navigator>
        </NavigationContainer>
    )
}

export default BottomTabNav;